import { Injectable, computed, signal } from '@angular/core';
import { DoublonsBusterApiService } from '../services/doublons-buster-api.service';

export const doublonsBusterActionCodes = {
  problematicMetadataCorrectionExecute: 'ProblematicMetadataCorrection.Execute',
  investorPersonsCorrectionExecute: 'InvestorPersonsCorrection.Execute',
  investorRelationDeletionExecute: 'InvestorRelationDeletion.Execute',
  investorPurgeExecute: 'InvestorPurge.Execute',
  consultantBouquetServiceSubscriptionManage: 'ConsultantBouquetServiceSubscription.Manage',
  aprilAdiIntegrationExecute: 'AprilAdiIntegration.Execute',
  exPostCampaignImport: 'ExPostCampaign.Import',
  exPostCampaignGenerate: 'ExPostCampaign.Generate',
  exPostEmailBatchSend: 'ExPostEmailBatch.Send',
  exPostDocumentsDownload: 'ExPostDocuments.Download',
  proxeemaSignatureStateUpdate: 'ProxeemaSignature.StateUpdate',
  proxeemaSignatureUniversignCancel: 'ProxeemaSignature.UniversignCancel',
  proxeemaSignatureGedCancel: 'ProxeemaSignature.GedCancel',
  proxeemaSignatureUniversignConfirm: 'ProxeemaSignature.UniversignConfirm'
} as const;

export type DoublonsBusterActionCode =
  (typeof doublonsBusterActionCodes)[keyof typeof doublonsBusterActionCodes];

@Injectable({
  providedIn: 'root'
})
export class ActionAuthorizationService {
  private readonly authorizedActionCodesState = signal<ReadonlySet<string>>(new Set<string>());

  readonly authorizedActionCodes = computed(() => [...this.authorizedActionCodesState()]);
  readonly loading = signal(false);

  constructor(private readonly apiService: DoublonsBusterApiService) {}

  load(): void {
    this.loading.set(true);

    this.apiService.getApplicationAuthorizations().subscribe({
      next: authorizations => {
        this.authorizedActionCodesState.set(new Set(authorizations.authorizedActionCodes));
        this.loading.set(false);
      },
      error: () => {
        this.clear();
        this.loading.set(false);
      }
    });
  }

  clear(): void {
    this.authorizedActionCodesState.set(new Set<string>());
  }

  canExecute(actionCode: DoublonsBusterActionCode): boolean {
    return this.authorizedActionCodesState().has(actionCode);
  }
}
